var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "dialog-container"
  }, [_c("my-dialog", {
    attrs: {
      modal: "",
      draggable: "",
      resizable: "",
      maximizable: "",
      minimizable: "",
      visible: _vm.visible,
      target: "body",
      title: "修改密码",
      "submit-visible": false,
      width: "460px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c("br"), _c("el-form", {
    ref: "form",
    staticStyle: {
      padding: "20px 40px"
    },
    attrs: {
      rules: _vm.rules,
      model: _vm.form,
      "label-position": "left",
      "label-width": "70px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "原密码",
      prop: "oldPassword"
    }
  }, [_c("el-input", {
    attrs: {
      type: "password"
    },
    model: {
      value: _vm.form.oldPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "oldPassword", $$v);
      },
      expression: "form.oldPassword"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "新密码",
      prop: "newPassword"
    }
  }, [_c("el-input", {
    attrs: {
      type: "password"
    },
    model: {
      value: _vm.form.newPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "newPassword", $$v);
      },
      expression: "form.newPassword"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "确认密码",
      prop: "confirmPassword"
    }
  }, [_c("el-input", {
    attrs: {
      type: "password"
    },
    model: {
      value: _vm.form.confirmPassword,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "confirmPassword", $$v);
      },
      expression: "form.confirmPassword"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("取消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };